export default __webpack_public_path__ + "static/media/phone-red.b4d805fa.svg";